const GET_CONCRETE_CLASSES_STATISTICAL_REQUEST =
  'GET_CONCRETE_CLASSES_STATISTICAL_REQUEST';
const GET_CONCRETE_CLASSES_STATISTICAL_SUCCESS =
  'GET_CONCRETE_CLASSES_STATISTICAL_SUCCESS';
const GET_CONCRETE_CLASSES_STATISTICAL_ERROR =
  'GET_CONCRETE_CLASSES_STATISTICAL_ERROR';

export {
  GET_CONCRETE_CLASSES_STATISTICAL_REQUEST,
  GET_CONCRETE_CLASSES_STATISTICAL_SUCCESS,
  GET_CONCRETE_CLASSES_STATISTICAL_ERROR,
};
